import React from "react";
import { styled } from "@mui/material/styles";
import ButtonBase, { ButtonBaseProps } from "@mui/material/ButtonBase";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import CloseIcon from "@mui/icons-material/Close";

import { Chip, IconButton, Typography } from "@mui/material";
import { BasketContext } from "../../../../Layouts/Dashboard/dashboard";
import { useContext } from "react";
import { basketService } from "../../../../Core/Api/services";
import {
  GetBasketItems,
  IsLoadedBasket,
  IsLoadingBasket,
  SetLoaded,
  StoreInitialState,
} from "../../../../Redux/Reducers/redux-slice-basket";
import { useDispatch, useSelector } from "react-redux";
import { UserHasAcl } from "../../../../Utils/helpers";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import { useTranslation } from "react-i18next";

export const PAGEHEADORDER_WIDTH: number = 320;
export const PAGEHEADORDER_WIDTH_CLOSED: number = 0;

interface OrderButtonProps extends ButtonBaseProps {
  openBasket?: boolean;
}

export const OrderButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "openBasket",
})<OrderButtonProps>(({ theme, openBasket }) => ({
  position: "relative",
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  fontWeight: 500,
  borderRadius: theme.shape.borderRadius,
  fontFamily: theme.typography.fontFamily,
  borderLeft: !openBasket ? `1px solid ${theme.palette.backgroundAlpha.border}` : "none",
  "&:hover, &.Mui-focusVisible": {
    backgroundColor: !openBasket ? theme.palette.backgroundAlpha.hover : "transparent",
  },
  transition: theme.transitions.create(["background-color"], {
    duration: theme.transitions.duration.short,
    easing: theme.transitions.easing.easeOut,
  }),
}));

export interface PageHeadOrderProps {}

const PageHeadOrder: React.FC<PageHeadOrderProps> = (props) => {
  const { t } = useTranslation();
  const { openBasket, setOpenBasket } = useContext(BasketContext);
  // Redux
  const dispatch = useDispatch();
  const isLoading = useSelector(IsLoadingBasket);
  const isLoaded = useSelector(IsLoadedBasket);
  const basketItems = useSelector(GetBasketItems);

  const acl = UserHasAcl(AclTypes.aclSectionOrderAccess);

  const handleClick = () => {
    setOpenBasket(!openBasket);
  };

  React.useEffect(() => {
    if (isLoaded || !acl) return;

    // Load for first time basket quickview and store it on Redux
    basketService.GetBasketQuickView().then(function (response) {
      dispatch(StoreInitialState(response.basket?.items));
      dispatch(SetLoaded(true));
    });
  }, [isLoading, dispatch, isLoaded]);

  return (
    <>
      {!openBasket && (
        <OrderButton focusRipple openBasket={openBasket} onClick={handleClick} id="tutorial-orders" disabled={!acl}>
          <ShoppingBagOutlinedIcon sx={{ mr: 1, color: "text.primary" }} />
          <Typography color="text.primary" id="tutorial-uikit-demo-orderPanel" component="span" fontWeight={500}>
            {t("component:body.myBasket")}
          </Typography>
          <Chip color="primary" size="small" label={isLoading || !acl ? "0" : basketItems?.length} sx={{ ml: 1 }} />
        </OrderButton>
      )}
    </>
  );
};

export default PageHeadOrder;
